import styled from "styled-components"
import VariantContainer from "./variant-container"

export default styled(VariantContainer)`
  grid-column: 1/-1;
  border-bottom: 1px solid var(--body-text-grey);
  width: 100%;
  opacity: 0.25;
`
